/**
 * Reports visibility (v3.79.0) — ONE predicate for the /reports/class route
 * and the "Reports" sidebar group, the canSeeSchoolView pattern: with the
 * flag off (prod today) neither renders. Admission = exactly the teacher
 * tabs (teacher, EA, legacy role-less accounts; never a pure admin, district
 * admin or TLS).
 */
import { isFeatureEnabled } from '../constants/featureFlags';
import { showsTeacherTabs } from './teacherTabs';

export function canSeeReports(user) {
  return isFeatureEnabled('reports') && !!user && showsTeacherTabs(user?.role);
}
